import { useEffect } from "react";

import { Box, Container, Stack, Text, Title } from "@mantine/core";
import { DateTime } from "luxon";
import { Helmet } from "react-helmet";

import { WhatsNewUpdate } from "../../content/updates/update";
import { latestUpdateId, updates } from "../../content/updates/updates";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { lastReadUpdateSlice } from "../../lib/state/reducer";

export const WhatsNewPage = (): JSX.Element => {
  const reduxDispatch = useAppDispatch();
  useEffect(() => {
    reduxDispatch(lastReadUpdateSlice.actions.setLastReadUpdateId(latestUpdateId));
  }, []);

  const latestUpdateDate = DateTime.fromISO(updates[0].date).toLocaleString(DateTime.DATE_FULL);

  return (
    <Container size="md" pt="xl" pb="xl">
      <Helmet>
        <title>What's New - {latestUpdateDate}</title>
      </Helmet>
      <Title order={1}>What's New</Title>
      <Stack pt={"md"} spacing="xl">
        {updates.map((update) => (
          <UpdateEntry key={update.id} update={update} />
        ))}
      </Stack>
    </Container>
  );
};

const UpdateEntry = ({ update }: { update: WhatsNewUpdate }): JSX.Element => {
  return (
    <Stack spacing="xs">
      <Stack spacing={0}>
        <Text c="gray.7" fz="md" fw={800}>
          {DateTime.fromISO(update.date).toLocaleString(DateTime.DATE_FULL)}
        </Text>
        <Title order={3}>{update.subject}</Title>
      </Stack>
      <Box>{update.content}</Box>
    </Stack>
  );
};
